import { list } from './user_countries';

export const user_countries = {
  namespaced: true,
  modules: {
    list
  }
};
